import { render, staticRenderFns } from "./ProjectTechnicalReview.vue?vue&type=template&id=09428e60&scoped=true"
import script from "./ProjectTechnicalReview.vue?vue&type=script&lang=js"
export * from "./ProjectTechnicalReview.vue?vue&type=script&lang=js"
import style0 from "./ProjectTechnicalReview.vue?vue&type=style&index=0&id=09428e60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09428e60",
  null
  
)

export default component.exports